<template>
  <div :class="{ 'bg-custom': !nightMode, 'bg-dark': nightMode }" class="p-st">
    <div class="container py-4">
      <div
        class="text-center"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="1000"
      >
        <span
          class="title text-center"
          :class="{ pgray: nightMode, 'text-light': nightMode }"
          >Skills.</span
        >
      </div>
      <hr
        width="50%"
        :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
      />
      <br />
      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-sm-12 pb-4 px-3"
          v-for="(skill, idx) in skills"
          :key="skill.title"
          data-aos="fade-up"
          data-aos-once="true"
          data-aos-duration="600"
          :style="{ 'animation-delay': idx * 0.1 + 's' }"
        >
          <div
            class="skill-card h-100"
            :class="{ 'card-light': !nightMode, 'card-dark': nightMode }"
          >
            <div class="card-header-row">
              <div class="icon-circle">
                <i :class="skill.icon"></i>
              </div>
              <span
                class="skill-title"
                :class="{ 'text-dark-mode': nightMode }"
                >{{ skill.title }}</span
              >
            </div>
            <div class="tags-wrap">
              <span
                v-for="tag in skill.info"
                :key="tag"
                class="skill-tag"
                :class="{ 'tag-dark': nightMode }"
                >{{ tag }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Skills",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      skills: info.skills,
    };
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
}

.skill-card {
  border-radius: 14px;
  padding: 22px 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.skill-card:hover {
  transform: translateY(-4px);
}

.card-light {
  background-color: #ffffff;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
  border: 1px solid #ebebeb;
}

.card-dark {
  background-color: #2a2f36;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3);
  border: 1px solid #3c4148;
}

.card-header-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.icon-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #669db3 0%, #02aab0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-circle i {
  font-size: 18px;
  color: #fff;
}

.skill-title {
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
  color: #2c3e50;
}

.text-dark-mode {
  color: #f0f0f0;
}

.tags-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.skill-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  background-color: #eef6f9;
  color: #3a7d96;
  border: 1px solid #c5dfe8;
  transition: background-color 0.2s;
}

.skill-tag:hover {
  background-color: #669db3;
  color: #fff;
  border-color: #669db3;
}

.tag-dark {
  background-color: #1e3a42;
  color: #7ec8dc;
  border-color: #2d5a6b;
}

.tag-dark:hover {
  background-color: #02aab0;
  color: #fff;
  border-color: #02aab0;
}
</style>
